import { useEffect } from "react";

export const CLIENT_CHANGED_EVENT = "prospo-client-changed";

/**
 * Announces that the set of clients (or their linked contacts) has changed.
 *
 * The Home calendar's "not a Prospo client" banner is derived from a server-side
 * classification of each 1-1's counterparty, so it goes stale the moment a
 * client is created — including from a screen that knows nothing about the
 * calendar, like the Clients page. A window event keeps that decoupled: the
 * creating component announces, and any open view that cares re-derives.
 *
 * Same pattern as `useFileChangeListener`, for the same reason: these writes
 * bypass the listening view's own fetch calls.
 */
export const notifyClientChanged = (): void => {
  window.dispatchEvent(new CustomEvent(CLIENT_CHANGED_EVENT));
};

export function useClientChangeListener(onChanged: () => void): void {
  useEffect(() => {
    const handler = () => onChanged();
    window.addEventListener(CLIENT_CHANGED_EVENT, handler);
    return () => window.removeEventListener(CLIENT_CHANGED_EVENT, handler);
  }, [onChanged]);
}
